import { clone } from '@jack-henry/frontend-utils/functions';
import { StpSearchModelDto } from '@treasury/api/channel';
import { emptyCompanyAccount } from '../company/company-account.entity';

const nullSearchedStopPayment: StpSearchModelDto = {
    accounts: [
        {
            ...emptyCompanyAccount,
        },
    ],
    statuses: [{ id: 0, updatedDate: '', name: '' }],
    checkNumberType: '',
    checkNumber: '',
    checkNumberEnd: '',
    checkNumberStart: '',
    checkAmountType: '',
    checkAmount: 0,
    checkAmountEnd: 0,
    checkAmountStart: 0,
    checkDateType: '',
    checkDate: '',
    checkDateStart: '',
    checkDateEnd: '',
    createdDateType: '',
    createdDate: '',
    createdDateStart: '',
    createdDateEnd: '',
    payee: '',
};

export class SearchedStopPayment {
    constructor(protected dto = clone(nullSearchedStopPayment)) {}

    public get accounts() {
        return this.dto.accounts || [];
    }

    public get statuses() {
        return this.dto.statuses || [];
    }

    public get checkNumberType() {
        return this.dto.checkNumberType || '';
    }

    public get checkNumber() {
        return this.dto.checkNumber || '';
    }

    public get checkNumberEnd() {
        return this.dto.checkNumberEnd || '';
    }

    public get checkNumberStart() {
        return this.dto.checkNumberStart || '';
    }

    public get checkAmountType() {
        return this.dto.checkAmountType || '';
    }

    public get checkAmount() {
        return this.dto.checkAmount || 0;
    }

    public get checkAmountEnd() {
        return this.dto.checkAmountEnd || 0;
    }

    public get checkAmountStart() {
        return this.dto.checkAmountStart || 0;
    }

    public get checkDateType() {
        return this.dto.checkDateType || '';
    }

    public get checkDate() {
        return this.dto.checkDate || '';
    }

    public get checkDateStart() {
        return this.dto.checkDateStart || '';
    }

    public get checkDateEnd() {
        return this.dto.checkDateEnd || '';
    }

    public get createdDateType() {
        return this.dto.createdDateType || '';
    }

    public get createdDate() {
        return this.dto.createdDate || '';
    }

    public get createdDateStart() {
        return this.dto.createdDateStart || '';
    }

    public get createdDateEnd() {
        return this.dto.createdDateEnd || '';
    }

    public get payee() {
        return this.dto.payee || '';
    }
}
